import './assets/scss/main.scss';

import './assets/js/sliders.js';
import './assets/js/youtube.js';
import './assets/js/selects.js';
import './assets/js/spoilers.js';
import './assets/js/menu.js';
import './assets/js/readmore.js';
import './assets/js/file_inputs.js';